
import { PLACEHOLDER_DATA_URI } from '@/assets/placeholder'

// 采购单确认卡：按钮只在未终结态可点；done 显示订单号（点击拉起现有订单详情抽屉）；
// stale（DRAFT_EXPIRED/DRAFT_CHANGED）禁用按钮并提示重新整理——绝不静默下单（spec §18）。
export default {
  name: 'AssistantDraftCard',
  props: {
    card: { type: Object, required: true },
    busy: { type: Boolean, default: false }
  },
  computed: {
    view () { return this.card.view || {} },
    state () { return this.card.state || this.view.status || 'ready' },
    order () { return this.card.order || null },
    staleText () {
      return this.card.staleReason === 'DRAFT_EXPIRED' ? '已过期（20 分钟有效），请重新整理采购单' : '采购单已变更，请以最新一张为准'
    },
    stateText () {
      const s = this.state
      if (s === 'done') return '已下单'
      if (s === 'cancelled') return '已取消'
      if (s === 'stale') return '已失效'
      if (s === 'collecting') return '待补信息'
      return '待确认'
    },
    missingText () {
      const labels = { contact_name: '收货人姓名', contact_phone: '手机号', address_summary: '收货地址' }
      return (this.view.missing_fields || []).map(k => labels[k] || k).join('、')
    }
  },
  methods: {
    thumbOf (it) {
      const raw = it && it.image
      return (raw && this.$img(raw)) || PLACEHOLDER_DATA_URI
    },
    onThumbError (e) { e.target.src = PLACEHOLDER_DATA_URI }
  }
}
